import ToolbarPopover from "../../../Navigation/ContextualToolbar/ToolbarPopover/ToolbarPopover";
import { useRef, useImperativeHandle } from "react";
import { PhotoScaleContent } from "@/appComponents/Blocks/Composites/PhotoScalePopover/PhotoScaleContent";
import { GetWSMgr } from "@/Utils/StateLib";
import { isNullish } from "@theorgchartdev/storybook";

const PhotoScalePopover = ({ srcElement, onClose, toolbarPopoverProps }) => {
  const openCtrlRef = useRef(null);
  const handleRef = useRef(null);

  useImperativeHandle(
    toolbarPopoverProps?.otherPopoverProps?.openCtrlRef,
    () => openCtrlRef.current
  );

  const closePopover = () => {
    openCtrlRef?.current?.setOpen(false);
    if (onClose) onClose();
  };

  const triggerTestId = toolbarPopoverProps?.triggerTestId;
  const footerTestId = triggerTestId ? `${triggerTestId.replace(/-btn$/, "")}-popover` : undefined;

  const overlayProps = {
    footerProps: {
      "data-testid": footerTestId,
      footerActions: {
        cancelAction: () => closePopover(),
        confirmAction: () => handleRef.current.onSave()
      }
    }
  };

  const tooltipProps = structuredClone(toolbarPopoverProps?.iconProps?.tooltipProps);
  if (!isNullish(tooltipProps)) {
    tooltipProps.referenceOpenCtrlRef = openCtrlRef;
  }

  return (
    <ToolbarPopover
      {...toolbarPopoverProps}
      otherPopoverProps={{
        offsetOptions: -2,
        ...toolbarPopoverProps?.otherPopoverProps,
        openCtrlRef: openCtrlRef
      }}
      overlayProps={overlayProps}
      iconProps={{ ...toolbarPopoverProps?.iconProps, tooltipProps: tooltipProps }}
      key={5}
    >
      <PhotoScaleContent srcElement={srcElement} handleRef={handleRef} onClose={closePopover} />
    </ToolbarPopover>
  );
};

export default PhotoScalePopover;
